export default __webpack_public_path__ + "static/assets/3b276304ccf646e1e59dd6b5fa2133c9.png";